const HIDDEN_LESSON_IDS = new Set([
  496, 527, 557, 558, 623, 651, 886, 652, 880, 1304, 759, 763, 848, 942, 935,
  948, 964, 1014, 1040, 1099, 1247, 1306, 1307, 1308, 1320, 3267, 1296, 1392,
  1393, 1508, 351, 498, 491, 745, 760, 747, 790, 831, 844, 833, 467, 468, 463,
  479, 471, 616, 1505, 1552, 1553, 856, 947, 481, 485, 478, 674, 549,
  731, 748, 749, 750, 872, 808, 908, 958, 962, 953, 969, 1227, 975, 1041, 1220,
  1022, 1231, 1104, 1060, 1233, 1236, 1237, 1266, 1269, 1270, 1292, 1300, 1387,
  1424, 1434, 1441, 1594, 443, 440, 441,
]);

export const isLessonVisible = (lessonId: number): boolean =>
  !HIDDEN_LESSON_IDS.has(lessonId);
